import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
import menu from "../../src/mixins/global_methods/menu";
import {
  ROLE_ALL,
  ROLE_DOKTER,
  ROLE_DPM,
  ROLE_DPM_OPERATOR,
  ROLE_FARMASI,
  ROLE_FRONT_MANAGEMENT,
  ROLE_FRONTDESK,
  ROLE_KLINIK,
  ROLE_MANAGEMENT,
  ROLE_MANAGEMENT_DOKTER,
  ROLE_NON_MANAGEMENT,
  ROLE_PIC,
  ROLE_RIWAYAT_REKAM_MEDIS,
  ROLE_FRONT_NON_APOTEKER
} from "../helpers/constant";

Vue.use(VueRouter);

const routes = [
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
    meta: { auth: false },
  },
  {
    path: "/login",
    name: "login-page",
    component: () => import("../views/Login.vue"),
    meta: { layout: "examples", auth: false }
  },
  {
    path: "/idle",
    name: "idle-page",
    component: () => import("../views/Idle.vue"),
    meta: { layout: "examples", auth: false }
  },
  {
    path: "/sukses",
    name: "sukses-page",
    component: () => import("../views/HomePage.vue"),
    meta: { layout: "examples", auth: false }
  },
  {
    path: "/register",
    name: "register-page",
    component: () => import("../views/Register/RegisterKlinik.vue"),
    meta: { layout: "examples", auth: false }
  },
  {
    path: "/verification/password/:token",
    name: "verification-password",
    component: () => import("../views/VerificationPassword.vue"),
    meta: { layout: "examples", auth: false }
  },
  {
    path: "/set-password/:token?",
    name: "set-password",
    component: () => import("../views/SetPassword/Layout.vue"),
    meta: { layout: "examples", auth: false },
    props: true
  },
  {
    path: "/expired-set-password",
    name: "expired-set-password",
    component: () => import("../views/SetPassword/Expired.vue"),
    meta: { layout: "examples", auth: false },
  },
  {
    path: "/replaced-set-password",
    name: "replaced-set-password",
    component: () => import("../views/SetPassword/Replaced.vue"),
    meta: { layout: "examples", auth: false },
  },
  {
    path: "/activated-set-password",
    name: "activated-set-password",
    component: () => import("../views/SetPassword/Activated.vue"),
    meta: { layout: "examples", auth: false },
  },
  {
    path: "/forgot-password/:token?",
    name: "forgot-password",
    component: () => import("../views/ForgotPassword.vue"),
    meta: { layout: "examples", auth: false },
    props: true
  },
  {
    path: "/forgot_password/invalid",
    name: "forgot-password-failed",
    component: () => import("../views/ForgotPassword/ForgotExpired.vue"),
    meta: { layout: "examples", auth: false },
  },
  {
    path: "/permission-denied",
    name: "permission-denied",
    component: () => import("../views/layouts/PermissionDenied.vue"),
    meta: { layout: "examples", auth: true, role: ROLE_ALL },
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("../views/layouts/NotFound.vue"),
    meta: { layout: "examples", auth: true, role: ROLE_ALL },
  },
  {
    path: "/input-tarif",
    name: "input-tarif",
    component: () => import("../views/InputTarif.vue"),
    meta: { auth: true, role: ROLE_ALL },
    props: true,
  },
  {
    path: "/input-data-operator",
    name: "input-data-operator",
    component: () => import("../views/InputDataOperator.vue"),
    meta: { auth: true, role: ROLE_ALL },
  },
  {
    path: "/pilih-paket",
    name: "pilih-paket",
    component: () => import("../views/Subscription/PilihPaket.vue"),
    meta: { auth: true, role: ROLE_ALL },
  },
  {
    path: "/struk-subskripsi/:bill_id",
    name: "struk-subskripsi",
    component: () => import("../views/Subscription/StrukSubscription.vue"),
    meta: { auth: true, role: ROLE_DPM },
  },
  {
    path: "/init",
    component: () => import("../views/Initialization.vue"),
    meta: { auth: true, role: ROLE_DPM },
    children: [
      {
        path: "",
        name: "input-spesialisasi",
        component: () => import("../views/Initialization/InputSpesialisasi.vue"),
        meta: { auth: true, role: ROLE_DPM },
        props: true,
      },
      {
        path: "input-asisten-dokter",
        name: "input-asisten-dokter",
        component: () => import("../views/Initialization/InputDataAsistenDokter.vue"),
        meta: { auth: true, role: ROLE_DPM },
        props: true,
      },
    ]
  },
  {
    path: "/init-klinik",
    meta: { layout: "examples" },
    component: () => import("../views/Initialization.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
    children: [
      {
        path: "",
        name: "input-klinik",
        component: () => import("../views/Initialization/InputKlinik.vue"),
        meta: { layout: "examples", auth: true, role: ROLE_KLINIK },
        props: true,
      },
    ]
  },
  {
    path: "/verification",
    component: () => import("../views/Verification.vue"),
    meta: { auth: false },
    children: [
      {
        path: "",
        name: "verification-process",
        component: () => import("../views/Verification/VerificationProcess.vue"),
        meta: { layout: "examples", auth: false },
        props: true
      },
      {
        path: "login",
        name: "verification-login",
        component: () =>
          import("../views/Verification/VerificationLogin.vue"),
        meta: { layout: "examples", auth: false  },
        props: true
      },
      {
        path: "operator/:token",
        name: "verification-operator",
        component: () => import("../views/Verification/VerificationOperator.vue"),
        meta: { layout: "examples", auth: false  },
        props: true,
      },
      {
        path: ":state",
        name: "verification-result",
        component: () => import("../views/Verification/VerificationResult.vue"),
        meta: { layout: "examples", auth: false  },
        props: true,
      }
    ]
  },
  // DPM
  {
    path: "/rawat-jalan",
    component: () => import("../views/RawatJalan.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
    children: [
      {
        path: "antrean",
        name: "antrean-rawat-jalan",
        component: () => import("../views/RawatJalan/Antrean.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      },
      {
        path: "registrasi",
        name: "registrasi-rawat-jalan",
        component: () => import("../views/RawatJalan/Registrasi.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      }
    ]
  },
  {
    path: "/pembayaran",
    component: () => import("../views/Pembayaran.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
    children: [
      {
        path: ":bayar_id",
        name: "pembayaran-tambah",
        component: () => import("../views/Pembayaran/Tambah.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      },
      {
        path: "",
        name: "pembayaran-list",
        component: () => import("../views/Pembayaran/List.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      },
      {
        path: "struk/:pembayaran_id",
        name: "pembayaran-struk",
        component: () => import("../views/Pembayaran/StrukWrapper.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      }
    ]
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile/Profile.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
  },
  {
    path: "/subskripsi/pilih-paket",
    name: "subskripsi-pilih-paket",
    component: () => import("../views/Billing/BillingPilihPaket.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/subskripsi",
    name: "subskripsi",
    component: () => import("../views/Billing/List.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/subskripsi/paket/:type",
    name: "subskripsi-paket",
    component: () => import("../views/Subscription/Paket.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/subskripsi/detail/:id",
    name: "subskripsi-detail",
    component: () => import("../views/Subscription/DetailPaket.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/subskripsi/addons",
    name: "subskripsi-addons",
    component: () => import("../views/Subscription/DetailAddons.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/subskripsi/payment/:bill_id",
    name: "subskripsi-bayar",
    component: () => import("../views/Subscription/CaraPembayaran.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/bayarind/:bill_id",
    name: "subskripsi-bayarind",
    component: () => import("../views/Subscription/StatusInvoice.vue"),
    meta: { auth: true, role: ROLE_DPM  },
  },
  {
    path: "/tarif",
    name: "tarif",
    component: () => import("../views/Tarif.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
    children: [
      {
        path: "/tarif",
        name: "tarif-list",
        component: () => import("../views/Tarif/List.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      },
      {
        path: "/tarif/tambah",
        name: "tarif-tambah",
        component: () => import("../views/Tarif/Tambah.vue"),
        meta: { auth: true, role: ROLE_DPM_OPERATOR },
      }
    ]
  },
  {
    path: "/laporan-pendapatan",
    name: "laporan-pendapatan",
    component: () => import("../views/LaporanPendapatanPage.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
  },
  {
    path: "/patient-engagement",
    name: "patient-engagement",
    component: () => import("../views/AddOns/PatientEngagement.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
  },
  {
    path: "/rekam-medis",
    component: () => import("../views/RekamMedis/List.vue"),
    meta: { auth: true, role: ROLE_DPM },
  },
  {
    path: "/rekam-medis/riwayat/:pasien_id",
    name: "riwayat-rekam-medis",
    component: () => import("../views/RiwayatRekamMedis.vue"),
    meta: { auth: true, role: ROLE_DPM_OPERATOR },
    props: true,
  },
  {
    path: "/rekam-medis/:transklinik_id/:pasien_id",
    name: "rekam-medis-pasien",
    component: () => import("../views/RekamMedis.vue"),
    meta: { auth: true, role: ROLE_DPM },
  },

  // klinik,
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
    meta: { auth: true, role: ROLE_ALL },
    props: true,
  },
  {
    path: "/manajemen-tarif",
    component: () => import("../views/ManTarif.vue"),
    meta: { auth: true, role: ROLE_NON_MANAGEMENT },
    children: [
      {
        path: "",
        name: "manajemen-tarif-list",
        component: () => import("../views/ManajemenTarif/List.vue"),
        meta: { auth: true, role: ROLE_NON_MANAGEMENT },
      },
      {
        path: "tambah",
        name: "manajemen-tarif-tambah",
        component: () => import("../views/ManajemenTarif/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "upload",
        name: "upload-manajemen-tarif",
        component: () => import("../views/ManajemenTarif/Upload.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      },
      {
        path: "list-upload",
        name: "list-upload-manajemen-tarif",
        component: () => import("../views/ManajemenTarif/ListUpload.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      }
    ]
  },
  {
    path: "/klinik",
    component: () => import("../views/Klinik.vue"),
    meta: { auth: true, role: ROLE_MANAGEMENT  },
    children: [
      {
        path: "",
        name: "klinik-list",
        component: () => import("../views/Klinik/List.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT  },
      },
      {
        path: "tambah",
        name: "klinik-tambah",
        component: () => import("../views/Klinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT  },
      },
      {
        path: "edit/:klinik_id",
        name: "klinik-edit",
        component: () => import("../views/Klinik/Edit.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT  },
      }
    ]
  },

  //Change Klinik
  {
    path: "/change-klinik",
    name: "change-klinik",
    component: () => import("../views/UbahKlinik.vue"),
    meta: { layout: "examples", auth: true, role: ROLE_KLINIK },
    props: true
  },

  //PIC Klinik
  {
    path: "/pic-klinik",
    component: () => import("../views/PICKlinik.vue"),
    meta: { auth: true, role: ROLE_MANAGEMENT },
    children: [
      {
        path: "",
        name: "pic-klinik-list",
        component: () => import("../views/PICKlinik/List.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT },
      },
      {
        path: "tambah",
        name: "pic-klinik-tambah",
        component: () => import("../views/PICKlinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT },
      },
      {
        path: "edit/:user_id/:klinik_id",
        name: "pic-klinik-edit",
        component: () => import("../views/PICKlinik/Edit.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT },
      }
    ]
  },
  {
    path: "/staff",
    component: () => import("../views/Staff.vue"),
    meta: { auth: true, role: ROLE_PIC },
    children: [
      {
        path: "",
        name: "staff-list",
        component: () => import("../views/Staff/List.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "tambah",
        name: "staff-tambah",
        component: () => import("../views/Staff/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "edit/:user_id",
        name: "staff-edit",
        component: () => import("../views/Staff/Edit.vue"),
        meta: { auth: true, role: ROLE_PIC },
      }
    ]
  },
  {
    path: "/manajemen",
    component: () => import("../views/Manajemen.vue"),
    meta: { auth: true, role: ROLE_MANAGEMENT },
    children: [
      {
        path: "",
        name: "manajemen-list",
        component: () => import("../views/Manajemen/List.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT },
      },
      {
        path: "tambah",
        name: "manajemen-tambah",
        component: () => import("../views/Manajemen/Tambah.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT },
      },
      {
        path: "edit/:user_id",
        name: "manajemen-edit",
        component: () => import("../views/Manajemen/Edit.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT },
      }
    ]
  },
  {
    path: "/dokter",
    component: () => import("../views/Dokter.vue"),
    meta: { auth: true, role: ROLE_PIC },
    children: [
      {
        path: "",
        name: "dokter-list",
        component: () => import("../views/Dokter/List.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "tambah",
        name: "dokter-tambah",
        component: () => import("../views/Dokter/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "edit/:user_id",
        name: "dokter-edit",
        component: () => import("../views/Dokter/Edit.vue"),
        meta: { auth: true, role: ROLE_PIC },
      }
    ]
  },
  // Poliklinik
  {
    path: "/poliklinik",
    component: () => import("../views/Poliklinik.vue"),
    meta: { auth: true, role: ROLE_PIC },
    children: [
      {
        path: "",
        name: "poliklinik-list",
        component: () => import("../views/Poliklinik/List.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "tambah",
        name: "poliklinik-tambah",
        component: () => import("../views/Poliklinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "edit/:id_poli",
        name: "poliklinik-edit",
        component: () => import("../views/Poliklinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
        props: true
      },
    ]
  },
  {
    path: "/role-manajemen",
    component: () => import("../views/RoleManajemen.vue"),
    meta: { auth: true, role: ROLE_MANAGEMENT_DOKTER },
    children: [
      {
        path: "",
        name: "role-manajemen-list",
        component: () => import("../views/RoleManajemen/List.vue"),
        meta: { auth: true, role: ROLE_MANAGEMENT_DOKTER },
      }
    ]
  },
  // Pasien Klinik
  {
    path: "/pasien-klinik",
    component: () => import("../views/Pasien.vue"),
    meta: { auth: true, role: ROLE_FRONTDESK },
    children: [
      {
        path: "",
        name: "pasien-klinik-list",
        component: () => import("../views/PasienKlinik/List.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      },
      {
        path: "tambah",
        name: "pasien-klinik-tambah",
        component: () => import("../views/PasienKlinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      },
      {
        path: "edit/:idPasien",
        name: "pasien-klinik-edit",
        component: () => import("../views/PasienKlinik/Edit.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      },
      {
        path: "detail/:idPasien",
        name: "pasien-klinik-detail",
        component: () => import("../views/PasienKlinik/Detail.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
        props: true,
      },
      {
        path: "kartu/:id",
        name: "kartu-pasien-klinik",
        component: () => import("../views/PasienKlinik/KartuPasien.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      },
      {
        path: "upload",
        name: "upload-pasien-klinik",
        component: () => import("../views/PasienKlinik/Upload.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      },
      {
        path: "list-upload",
        name: "list-upload-pasien-klinik",
        component: () => import("../views/PasienKlinik/ListUpload.vue"),
        meta: { auth: true, role: ROLE_FRONTDESK },
      }
    ]
  },
  // Klinik Antrean
  {
    path: "/antrean-klinik",
    component: () => import("../views/AntreanKlinik.vue"),
    meta: { auth: true, role: ROLE_NON_MANAGEMENT },
    children: [
      {
        path: "",
        name: "antrean-klinik-list",
        component: () => import("../views/KlinikAntrean/List.vue"),
        meta: { auth: true, role: ROLE_NON_MANAGEMENT },
      },
      {
        path: "bridge",
        name: "antrean-klinik-brigde",
        component: () => import("../views/KlinikAntrean/Bridge.vue"),
        meta: { auth: true, role: ROLE_NON_MANAGEMENT },
      },
      {
        path: "tambah",
        name: "antrean-klinik-tambah",
        component: () => import("../views/KlinikAntrean/Tambah.vue"),
        meta: { auth: true, role: ROLE_NON_MANAGEMENT },
      },
      {
        path: "edit/:id",
        name: "antrean-klinik-edit",
        component: () => import("../views/KlinikAntrean/Tambah.vue"),
        meta: { auth: true, role: ROLE_NON_MANAGEMENT },

      },
    ],
  },
  // Rekam Medis Klinik
  {
    path: "/klinik/rekam-medis",
    name: "klinik-rekam-medis",
    component: () => import("../views/RM_Klinik/List.vue"),
    meta: { auth: true, role: ROLE_RIWAYAT_REKAM_MEDIS },
  },
  {
    path: "/klinik/rekam-medis/riwayat/:pasien_id",
    name: "klinik-rekam-medis-riwayat",
    component: () => import("../views/RM_Klinik/Riwayat.vue"),
    meta: { auth: true, role: ROLE_RIWAYAT_REKAM_MEDIS },
    props: true,
  },
  {
    path: "/klinik/rekam-medis/:transklinik_id/:pasien_id",
    name: "klinik-rekam-medis-pasien",
    component: () => import("../views/RM_Klinik/RekamMedis.vue"),
    meta: { auth: true, role: ROLE_DOKTER },
  },

  // Manajemen BHP
  {
    path: "/klinik/bhp",
    name: "klinik-list-bhp",
    component: () => import("../views/Bhp/List.vue"),
    meta: { auth: true, role: ROLE_NON_MANAGEMENT },
  },
  {
    path: "/klinik/bhp/tambah",
    name: "klinik-bhp-tambah",
    component: () => import("../views/Bhp/Form.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  {
    path: "/klinik/bhp/edit/:id",
    name: "klinik-bhp-edit",
    component: () => import("../views/Bhp/Form.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  {
    path: "/klinik/bhp/upload",
    name: "klinik-bhp-upload",
    component: () => import("../views/Bhp/Upload.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  {
    path: "/klinik/bhp/list-upload",
    name: "klinik-bhp-list-upload",
    component: () => import("../views/Bhp/ListUpload.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  // Obat Klinik
  {
    path: "/klinik/obat",
    name: "klinik-obat-list",
    component: () => import("../views/ObatKlinik/List.vue"),
    meta: { auth: true, role: ROLE_NON_MANAGEMENT },
  },
  {
    path: "/klinik/obat/tambah",
    name: "klinik-obat-tambah",
    component: () => import("../views/ObatKlinik/Tambah.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  {
    path: "/klinik/obat/:id",
    name: "klinik-obat-edit",
    component: () => import("../views/ObatKlinik/Edit.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  {
    path: "/klinik/obat/upload",
    name: "klinik-obat-upload",
    component: () => import("../views/ObatKlinik/Upload.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  {
    path: "/klinik/obat/list-upload",
    name: "klinik-obat-list-upload",
    component: () => import("../views/ObatKlinik/ListUpload.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
  },
  // Manajemen stok obat & bhp
  {
    path: "/klinik/stok",
    component: () => import("../views/StockManagement.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
    children: [
      {
        path: "obat",
        name: "klinik-stok-obat",
        component: () => import("../views/StokKlinik/Obat.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "obat/upload",
        name: "klinik-stok-obat-upload",
        component: () => import("../views/StokKlinik/ObatUpload.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "obat/list-upload",
        name: "klinik-stok-obat-list-upload",
        component: () => import("../views/StokKlinik/ObatListUpload.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "obat/tambah",
        name: "klinik-stok-obat-tambah",
        component: () => import("../views/StokKlinik/ObatForm.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "obat/edit/:id",
        name: "klinik-stok-obat-edit",
        component: () => import("../views/StokKlinik/ObatFormEdit.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "bhp",
        name: "klinik-stok-bhp",
        component: () => import("../views/StokKlinik/Bhp.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "bhp/tambah",
        name: "klinik-stok-bhp-tambah",
        component: () => import("../views/StokKlinik/BhpForm.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "bhp/edit/:id",
        name: "klinik-stok-bhp-edit",
        component: () => import("../views/StokKlinik/BhpFormEdit.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "bhp/upload",
        name: "klinik-stok-bhp-upload",
        component: () => import("../views/StokKlinik/UploadBhp.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "bhp/list-stok-upload",
        name: "klinik-stok-bhp-list-upload",
        component: () => import("../views/StokKlinik/ListUpload.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "report",
        name: "klinik-stok-report",
        component: () => import("../views/StokKlinik/Report.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "report/:id/stock",
        name: "klinik-stok-report-detail",
        component: () => import("../views/StokKlinik/ReportDetail/DetailStock.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: "report/:id/sell-stock",
        name: "klinik-stok-report-detail-sell",
        component: () => import("../views/StokKlinik/ReportDetail/DetailSellStock.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      }
    ]
  },
  // Account Setting
  {
    path: "/account-setting/klinik",
    name: "account-setting-klinik",
    component: () => import("../views/AccountSettingKlinik/WrapperProfile.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/jadwal_dan_fasilitas",
    name: "account-setting-fasilitas",
    component: () => import("../views/AccountSettingKlinik/Fasilitas.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/profile",
    name: "account-setting-profile",
    component: () => import("../views/AccountSettingKlinik/DataProfile.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/skema-komisi",
    name: "account-setting-skema-komisi",
    component: () => import("../views/AccountSettingKlinik/SkemaKomisi.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/bridging-bpjs",
    name: "account-setting-bridging-bpjs",
    component: () => import("../views/AccountSettingKlinik/BridgingBPJS.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/bridging-satu-sehat",
    name: "account-setting-bridging-satu-sehat",
    component: () => import("../views/AccountSettingKlinik/BridgingSatuSehat.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/setting-location",
    name: "account-setting-setting-location",
    component: () => import("../views/AccountSettingKlinik/SettingLocation.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },
  {
    path: "/account-setting/verification-code",
    name: "account-setting-verification-code",
    meta: { layout: "examples" },
    component: () => import("../views/AccountSettingKlinik/VerificationCode.vue"),
    meta: { auth: true, role: ROLE_KLINIK },
  },

  // account setting - PIC
  {
    path: "/account-setting/faskes-profile",
    name: "account-setting-faskes-profile",
    component: () => import("../views/AccountSettingKlinik/Pic/FaskesProfile.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },
  {
    path: "/account-setting/faskes-setting",
    name: "account-setting-faskes-setting",
    component: () => import("../views/AccountSettingKlinik/Pic/FaskesSetting.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },

  // Klinik Pembayaran
  {
    path: "/klinik/pembayaran",
    component: () => import("../views/Pembayaran.vue"),
    meta: { auth: true, role: ROLE_FRONT_NON_APOTEKER },
    children: [
      {
        path: "/",
        name: "klinik-pembayaran-list",
        component: () => import("../views/PembayaranKlinik/List.vue"),
        meta: { auth: true, role: ROLE_FRONT_NON_APOTEKER },
      },
      {
        path: ":bayar_id",
        name: "klinik-pembayaran-tambah",
        component: () => import("../views/PembayaranKlinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_FRONT_NON_APOTEKER },
      },
      {
        path: "struk/:pembayaran_id",
        name: "klinik-pembayaran-struk",
        component: () => import("../views/PembayaranKlinik/Struk.vue"),
        meta: { auth: true, role: ROLE_FRONT_NON_APOTEKER },
      }
    ]
  },
  // Klinik Subscription
  {
    path: "/klinik/subskripsi",
    name: "klinik-subskripsi",
    component: () => import("../views/BillingKlinik/List.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },
  {
    path: "/klinik/subskripsi/pilih-paket",
    name: "klinik-subskripsi-pilih-paket",
    component: () => import("../views/BillingKlinik/BillingPilihPaket.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },
  {
    path: "/klinik/subskripsi/paket/:type",
    name: "klinik-subskripsi-paket",
    component: () => import("../views/SubscriptionKlinik/Paket.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },
  {
    path: "/klinik/subskripsi/payment/:bill_id",
    name: "klinik-subskripsi-bayar",
    component: () => import("../views/SubscriptionKlinik/CaraPembayaran.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },
  {
    path: "/klinik/struk-subskripsi/:bill_id",
    name: "struk-klinik-subskripsi",
    component: () => import("../views/SubscriptionKlinik/StrukSubscription.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },

  {
    path: "/klinik/bayarind/:bill_id",
    name: "klinik-subskripsi-bayarind",
    component: () => import("../views/SubscriptionKlinik/StatusInvoice.vue"),
    meta: { auth: true, role: ROLE_PIC },
  },

  // Klinik Survey
  {
    path: "/klinik/komisi",
    component: () => import("../views/KomisiKlinik.vue"),
    meta: { auth: true, role: ROLE_PIC },
    children: [
      {
        path: "/",
        name: "klinik-komisi-list",
        component: () => import("../views/KomisiKlinik/List.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "tambah",
        name: "klinik-komisi-tambah",
        component: () => import("../views/KomisiKlinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "edit/:idComition",
        name: "klinik-komisi-edit",
        component: () => import("../views/KomisiKlinik/Tambah.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "report",
        name: "klinik-komisi-report",
        component: () => import("../views/KomisiKlinik/Report.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
      {
        path: "report/:user_id/:role_id?",
        name: "klinik-komisi-report-detail",
        component: () => import("../views/KomisiKlinik/ReportDetail.vue"),
        meta: { auth: true, role: ROLE_PIC },
      },
    ]
  },
  //Halaman Survey
  {
    path: "/survey",
    name: "survey",
    meta: { layout: "examples" },
    component: () => import("../views/Initialization/Survey.vue"),
    meta: { auth: true, role: ROLE_ALL },
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("../views/Reset.vue"),
    meta: { auth: true, role: ROLE_ALL },
  },
  {
    path: "/subskripsi-info",
    name: "subskripsi-info",
    component: () => import("../views/SubskripsiInfo.vue"),
    meta: { auth: true, role: ROLE_ALL },
  },

  //Farmasi
  {
    path: "/klinik/farmasi",
    component: () => import("../views/Farmasi.vue"),
    meta: { auth: true, role: ROLE_FARMASI },
    children: [
      {
        path: "",
        name: "klinik-farmasi-list",
        component: () => import("../views/Farmasi/List.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
      {
        path: ":id",
        name: "farmasi-detail",
        component: () => import("../views/Farmasi/Detail.vue"),
        meta: { auth: true, role: ROLE_FARMASI },
      },
    ]
  },
  //Penjualan
  {
    path: "/klinik/penjualan",
    component: () => import("../views/Penjualan.vue"),
    meta: { auth: true, role: ROLE_FRONT_MANAGEMENT },
    children: [
      {
        path: "",
        name: "klinik-penjualan-list",
        component: () => import("../views/Penjualan/List.vue"),
        meta: { auth: true, role: ROLE_FRONT_MANAGEMENT },
      },
      {
        path: "tambah",
        name: "klinik-penjualan-tambah",
        component: () => import("../views/Penjualan/Add.vue"),
        meta: { auth: true, role: ROLE_FRONT_MANAGEMENT },
      },
      {
        path: "tambah/:id",
        name: "klinik-penjualan-tambah-save",
        component: () => import("../views/Penjualan/Add.vue"),
        meta: { auth: true, role: ROLE_FRONT_MANAGEMENT },
      },
      {
        path: "struk/:id",
        name: "klinik-penjualan-struk",
        component: () => import("../views/Penjualan/Struk.vue"),
        meta: { auth: true, role: ROLE_FRONT_MANAGEMENT },
      }
    ]
  },
  //KYC
  {
    path: "/klinik/kyc",
    name: "klinik-kyc",
    component: () => import("../views/Kyc/SatusehatKyc.vue"),
    meta: { auth: true, role: ROLE_NON_MANAGEMENT },
  },
  // Logout from active client
  {
    path: "/logout/:client",
    name: "logout-client",
    component: () => import("../views/LogoutClient.vue"),
    meta: { layout: "examples", auth: true, role: ROLE_ALL },
  }
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return window.scrollTo({ top: 0, behavior: "smooth" });
  },
  routes
});

router.beforeEach((to, from, next) => {
  const { name } = to;

  let route = null;
  for (let n in routes) {
    if (routes[n] && routes[n].children) {
      const child = routes[n].children.find(c => c.name == name);
      if (child) {
        route = child;
        break;
      }
    } else if (routes[n].name == name){
      route = routes[n];
      break;
    }
  }
  if (!route) next('/login');

  localStorage.setItem('PREVENT_IDLE', 1);

  const isAuthenticated = store.state.BEARER_TOKEN !== null;
  const isRouteAuth = route.meta && route.meta.auth;

  if (['reset'].includes(name)) next();
  else if (!isAuthenticated && isRouteAuth) next('/login');
  else if (isAuthenticated && !isRouteAuth) next('/');
  else {
    if (isAuthenticated) {
      const access = menu.checkMenuAccess(route);
      if (!access) next('/permission-denied');
    }
    next();
  }
});

export default router;
